import React from "react";
import { Control, Select } from "@allxsmith/bestax-bulma";




export default function DepartmentPicker({departments, onDepartmentChange, selectedDepartment, showAll=true, disabled=false}){
  return (
    <div>
      <label className="label">Department</label>
      <Control>
        <Select
          name="departments"
          value={selectedDepartment ? selectedDepartment : 0}
          onChange={e => onDepartmentChange(e)}
          disabled={disabled}
        >
            {showAll && <option key={0} value={0}>All</option>}
          {departments.results.map(value => (
            <option key={value.id} value={value.id}>
              {value.name}
            </option>
          ))}
        </Select>
      </Control>
    </div>
  );
};